import React from 'react'
import AutoLayout from 'subapps/chat/components/AutoLayout'
import RoomListWithHeader from 'subapps/chat/components/RoomListWithHeader'
import Chat from 'subapps/chat/components/Chat'
import Modals from 'subapps/chat/components/Modals'
import { useChatLanding } from 'ducks/folders/hooks/page'

import RightSidebar from 'components/App/DesktopView/Layout/RightSidebar'

const COLUMN_CONFIGS = {
  '3-overview': [0],
  '3-page': [1, 2],
  '4': [0, 1, 2],
}

export default function ChatPage({ roomId, eventId }) {
  useChatLanding()

  return (
    <React.Fragment>
      <AutoLayout
        conversationId={roomId}
        columnConfigs={COLUMN_CONFIGS}
        sidebarType="widget"
        sidebarTitle="Chat"
      >
        <RoomListWithHeader channelType="widget" />
        {roomId ? <Chat roomId={roomId} eventId={eventId} /> : <div />}
        <RightSidebar />
      </AutoLayout>
      <Modals />
    </React.Fragment>
  )
}
